export enum CalculatorPrivacyStatus {
  PUBLIC_BASIC = 'PUBLIC_BASIC',
  PUBLIC_ALL = 'PUBLIC_ALL',
}
